import React, { useState } from 'react';
import './Home.css';

function Home() {
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  const testimonials = [
    { rating: 5, text: "Amazing quality and super comfortable clothing.", name: "Sarah W" },
    { rating: 5, text: "Perfect adaptive features. Loved it!", name: "James T" },
    { rating: 4, text: "My son loves the sensory collection.", name: "Linda" },
    { rating: 5, text: "Great customer service and fast shipping.", name: "Michelle" },
    { rating: 5, text: "Stylish adaptive clothing!", name: "Aaron P" },
    { rating: 4, text: "Very thoughtful design.", name: "Evelyn K" },
    { rating: 5, text: "Highly recommend TSU.", name: "Bishal" }
  ];

  const getVisibleTestimonials = () => {
    return testimonials.slice(testimonialIndex, testimonialIndex + 3);
  };

  const nextTestimonials = () => {
    if (testimonialIndex < testimonials.length - 3) {
      setTestimonialIndex(testimonialIndex + 1);
    }
  };

  const prevTestimonials = () => {
    if (testimonialIndex > 0) {
      setTestimonialIndex(testimonialIndex - 1);
    }
  };

  const renderStars = (rating) => {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  return (
    <div className="home">
      {/* Hero Image */}
      <div className="hero-section">
        <div className="hero-image">
          <img
            src="/image/homepagehero.png"
            alt="Shapes United - Inclusive Fashion"
            className="hero-img"
          />
        </div>
      </div>

      {/* Collections Title */}
      <div className="section">
        <h2 className="section-title">OUR COLLECTIONS</h2>
      </div>

      {/* Two Collections Side by Side */}
      <div className="collections-section">
        <div className="collection-card adaptive">
          <img 
            src="https://image-cdn.hypb.st/https%3A%2F%2Fhypebeast.com%2Fwp-content%2Fblogs.dir%2F6%2Ffiles%2F2021%2F09%2Fjillian-mercado-tommy-hilfiger-adaptive-collection-revolutionizing-dressing-collection-release-2.jpg?q=75&w=800&cbr=1&fit=max" 
            alt="Adaptive Collection" 
            className="collection-img"
          />
          <div className="collection-content">
            <h3>ADAPTIVE COLLECTION</h3>
            <p>Designed for ease of dressing with innovative features</p>
          </div>
        </div>
        <div className="collection-card sensory">
          <img 
            src="https://ecocult.com/wp-content/uploads/2024/06/sensory-friendly-featured.png" 
            alt="Sensory Collection" 
            className="collection-img"
          />
          <div className="collection-content">
            <h3>SENSORY COLLECTION</h3>
            <p>Soft, tag-free fabrics for sensory comfort</p>
          </div>
        </div>
      </div>

      {/* Brand Story Section */}
      <div className="brand-section">
        <div className="container">
          <div className="brand-left">
            <div className="brand-image">
              <img 
                src="https://images.stockcake.com/public/c/6/d/c6d61336-bbc0-4f56-9439-1d87480c86a4_large/joyful-friends-laughing-stockcake.jpg" 
                alt="Our Story" 
                className="brand-img"
              />
            </div>
          </div>
          <div className="brand-right">
            <h2>WE ARE THE ADAPTIVE CLOTHING BRAND FOR THOSE WITH THEIR OWN PHYSICAL STORIES TO TELL.</h2>
            <p>We own all of our differences; offering fashion that aims to be kind to the world and the people in it.</p>
            <p>We make it possible for our customers to express themselves through adaptive, sensory friendly clothing, and inclusive fashion and design. We choose a more sustainable lifestyle incorporating circular fashion.</p>
            <p>The brand mixes urban cool with a bold and definitive style. We are all about being brave, friendly, and fun while enabling everyone to embrace their own look.</p>
            <p className="hashtag">#wearetheshapesunited</p>
            <button className="learn-more-btn">Learn More</button>
          </div>
        </div>
      </div>

      {/* Testimonials */}
      <div className="testimonials-section">
        <h2 className="section-title">LET CUSTOMERS SPEAK FOR US</h2>
        <div className="testimonials-container">
          <button className="testimonial-nav prev" onClick={prevTestimonials}>‹</button>
          
          <div className="testimonials-grid">
            {getVisibleTestimonials().map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="stars">{renderStars(testimonial.rating)}</div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <p className="testimonial-name">- {testimonial.name}</p>
              </div>
            ))}
          </div>
          
          <button className="testimonial-nav next" onClick={nextTestimonials}>›</button>
        </div>
        
        <div className="testimonial-dots">
          {[...Array(testimonials.length - 2)].map((_, index) => (
            <button
              key={index}
              className={`dot ${index === testimonialIndex ? 'active' : ''}`}
              onClick={() => setTestimonialIndex(index)}
            />
          ))}
        </div>
      </div>

      {/* Simple Image Banner */}
      <div className="image-banner-section">
        <div className="image-banner-container">
          <img 
            src={encodeURI("/image/Screenshot 2025-12-08 at 7.27.41 pm.png")} 
            alt="Shapes United - Inclusive Fashion" 
            className="banner-image"
          />
        </div>
      </div>  

      {/* Second Image Banner */}
      <div className="image-banner-section second-banner">
        <div className="image-banner-container">
          <img 
            src={encodeURI("/image/Screenshot 2025-12-08 at 7.34.12 pm.png")} 
            alt="Shapes United Collection" 
            className="banner-image"
          />
        </div>
      </div>

      {/* About Text */}
      <div className="about-section">
        <div className="about-container">
          <h2 className="about-title">About The Shapes United</h2>
          <div className="about-content">
            <p className="about-text">
              The Shapes United is a fashionable adaptive clothing, inclusive, and accessible clothing label from Melbourne, Australia.
            </p>
            <p className="about-text">
              Great designs that are soft, seamless, tagless, and a dream to wear. Find the clothes to get out to the event you've been looking forward to, without the stress of how to get it on.
            </p>
            <p className="about-text">
              We offer sensory clothing and adaptive wear clothing to have you out and about in no time.
            </p>
          </div>
        </div>
      </div>

      {/* Contact Form */}
      
          
          {/* Right side - Address & Social Media */}
         
            
           
            
            
            
            
        </div>
      
    
  );
}

export default Home;
